import React, { useState } from "react";
import { MdEdit, MdOutlineDeleteForever } from "react-icons/md";
import { SubCategoryService } from "../../Services";
import { toast } from "react-toastify";
import { Button, Modal, Spinner } from "react-bootstrap-v5";

const CategoryDetail = ({ catdetail , handleSubcategory, viewid}) => {
  const [deleteModal, setDeleteModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [editModal, setEditModal] = useState(false);
  const [subcategory, setSubcategory] = useState("");
  const [editId, setEditId] = useState("");

  // const handleDeleteModal = async (id) => {
  //   setDeleteModal(true);
  //   setDeleteId(id);
  // };

  // const handleDelete = async (id) => {
  //   let obj = { id: deleteId };
  //   await SubCategoryService.deleteCategory(obj)
  //     .then((res) => {
  //       if (res.status === true) {
  //         toast.success(res.message);
  //         handleSubcategory(viewid)
  //       } else {
  //         toast.error(res.message);
  //       }
  //       setDeleteModal(false);
  //     })
  //     .catch((error) => {
  //     });
  // };

  const handleInput = (e) => {
    setSubcategory(e.target.value);
  };

  const handleOpenEdit = (item) => {
    setEditId(item._id);
    setSubcategory(item.subcategory_name);
    setEditModal(true);
  };

  const handleEdit = async (e) => {
    const obj = {
      id: editId,
      subcategory_name: subcategory,
    };
    await SubCategoryService.updateCategory(obj)
      .then((res) => {
        if (res?.status === true) {
          toast.success(res.message);
          handleSubcategory(viewid)
        } else {
          toast.error(res.message);
        }
        setEditModal(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };



  return (
    <>
      {(!deleteModal && !editModal) && (
        <div>
              <h5>Sub Category</h5>
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-centered table-nowrap mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>S no.</th>
                      <th> Name</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {catdetail &&
                      catdetail.map((item, key) => {
                        return (
                          <tr key={key}>
                            <td className="text-body fw-bold">{key + 1}</td>
                            <td>{item?.subcategory_name || ""}</td>
                            <td>
                              <MdEdit
                                className="pointer"
                                onClick={() => handleOpenEdit(item)}
                                style={{
                                  fontSize: "22px",
                                  color: "rgb(3, 35, 254)",
                                }}
                              />

                              {/* <MdOutlineDeleteForever
                                className="pointer"
                                onClick={() => handleDeleteModal(item._id)}
                                style={{ fontSize: "22px", color: "red" }}
                              /> */}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )
      
      }
      {/* <Modal
        show={deleteModal}
        onHide={() => setDeleteModal(false)}
        animation={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Sub Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure want to delete the category?</Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={() => setDeleteModal(false)}>
            No
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            {(loader && <Spinner animation="grow" size="sm" />) || "Yes"}
          </Button>
        </Modal.Footer>
      </Modal> */}

      {/* Edit Modal */}

      <Modal
        show={editModal}
        onHide={() => setEditModal(false)}
        animation={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Sub Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3 col-12">
            <input
              type="text"
              className="form-control"
              name="subcategory_name"
              value={subcategory}
              placeholder="Name"
              onChange={(e) => handleInput(e)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={() => setEditModal(false)}>
            No
          </Button>
          <Button variant="danger" onClick={handleEdit}>
            Yes
            {/* "} */}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CategoryDetail;
